<div class="flex flex-col justify-center items-center mt-4 mb-10"
     *transloco="let t; read: 'home.contact_us'">
  <psc-section-title
    [title]="t('title')"
    [subtitle]="t('subtitle')"
  ></psc-section-title>
  <form [formGroup]="formGroup" class="flex flex-col w-[90%] mt-4 md:w-1/2 xl:w-1/4 md:shrink-0"
        (keydown.enter)="onSubmit()">
    <psc-input type="email"
               formControlName="email"
               [label]="t('email')"></psc-input>

    <psc-input formControlName="subject"
               [label]="t('subject')"></psc-input>

    <psc-textarea formControlName="message"
                  [label]="t('query')">
    </psc-textarea>


    <psc-button class="pt-6 pb-4"
                [label]="t('send')"
                (buttonClicked)="onSubmit()"
                [disabled]="!formGroup.valid"
                type="primary-blue-2"></psc-button>
  </form>
</div>
